<template>
    <div class="root-node-wrapper" :class="{ 'root-node-selected': isSelected }" @click="selectRoot">
        <div>
            {{ data.label }}
            <em class="small-label" v-if="data.smallLabel">({{ data.smallLabel }})</em>
        </div>
        <a class="add-button" @click="addHandler" v-if="editable"></a>
    </div>
</template>

<script>
export default {
    name: "RootNode",
    props: ["data", "editable", "isSelected"],
    methods: {
        addHandler(data) {
            this.$emit("operatorClick", {
                id: data.id,
                path: "",
                isRoot: true,
                opr: "add"
            });
        },
        selectRoot() {
            this.$emit("selectRoot");
        }
    }
};
</script>

<style lang="less" scoped>
.root-node-wrapper {
    display: flex;
    font-size: 14px;
    padding: 10px 8px 10px 16px;
    justify-content: space-between;
    flex-shrink: 0;
    cursor: pointer;
    > div {
        margin-top: 3px;
    }
    .small-label {
        font-size: 12px;
        color: #9b9ba3;
    }

    .add-button {
        cursor: pointer;
        display: inline-block;
        background: url("@{zhijiStaticImagePath}class-spr.png");
        width: 24px;
        height: 24px;
        background-position: -27px -25px;

        &:hover {
            background-position: -27px 0;
        }
    }

    &:hover {
        background: rgba(217, 235, 246, 0.7);
        color: #2ec2ff;

        .small-label {
            color: #2ec2ff;
        }
    }
}

.root-node-selected {
    color: #2ec2ff;
    background: rgba(217, 235, 246, 1);
    .small-label {
        color: #2ec2ff;
    }
}
</style>
